import { createContext } from "react";

type ContextContents = {
	courseId: number;
	proctoringSessionId: string;
	config: {
		showFlaggedOnly: boolean;
		sessionInProgress: boolean;
	};
};
export const ProctoringResultsContext = createContext<ContextContents>({} as ContextContents);
